import React from 'react';

import { ConfirmationModal } from 'components/modal';

type Props = {
  onConfirm: () => void;
  onRequestClose: () => void;
};

export const ConfirmPlaylistRemovalModal = ({ onConfirm, onRequestClose }: Props) => (
  <ConfirmationModal
    title='Delete playlist?'
    onConfirm={onConfirm}
    onRequestClose={onRequestClose}
    dangerLabel='Remove'
    cancel={true}
    isOpen
  >
    Are you sure you want to delete this playlist?
  </ConfirmationModal>
);
